/**
 * Checks if the given organizationId is present in the provided array of orgIdsArray.
 * @param  organizationId - The ID of the organization to check.
 * @param  orgIdsArray - An array of organization IDs to search in.
 * @returns  Returns true if the organizationId is found in the orgIdsArray, otherwise false.
 */
export function checkIsOrgSpecific(organizationId, orgIdsArray = []) {
  return orgIdsArray.includes(organizationId);
}
